import { Pipe, PipeTransform } from '@angular/core';

import { WrappedValue, wrapValue } from '../mailgun/wrap-value';

@Pipe({
  name: 'mailgunMarkAsHtml',
  standalone: true,
})
export class MailgunMarkAsHtmlPipe implements PipeTransform {
  public transform(value: WrappedValue<any>): any {
    return wrapValue(value.toPath(), value.toValue(), {
      asHtml: true,
      ...value.getOpts(),
    });
  }
}
